import { useEffect, useState } from 'react';
import { isNewBuild } from '../../utils/appVersion';

export function UpdateNotice() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    if (!import.meta.env.PROD) return;

    let disposed = false;
    let checking = false;
    const check = async () => {
      if (disposed || checking || document.visibilityState === 'hidden') return;
      checking = true;
      const newer = await isNewBuild(__APP_BUILD_VERSION__);
      checking = false;
      if (!disposed && newer) setAvailable(true);
    };
    const checkWhenVisible = () => {
      if (document.visibilityState === 'visible') void check();
    };

    void check();
    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', checkWhenVisible);
    const interval = window.setInterval(check, 5 * 60 * 1000);
    return () => {
      disposed = true;
      window.removeEventListener('focus', check);
      document.removeEventListener('visibilitychange', checkWhenVisible);
      window.clearInterval(interval);
    };
  }, []);

  if (!available) return null;

  return (
    <div role="status" className="fixed right-4 top-20 z-[60] max-w-sm rounded-lg border border-blue-300 bg-white p-4 text-gray-900 shadow-lg dark:border-blue-700 dark:bg-gray-800 dark:text-gray-100">
      <p className="font-semibold">An update is available</p>
      <p className="mt-1 text-sm">Reload when you are ready to see the latest changes.</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="mt-3 min-h-11 rounded-md bg-blue-600 px-4 py-2 font-medium text-white hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
      >
        Reload
      </button>
    </div>
  );
}
